import React, { useEffect, useMemo, useRef, useState } from "react";
import "./client-Details-Style.css";
import { Box, CircularProgress, Popover } from "@mui/material";
import SearchAndSelect from "./components/SearchAndSelect";
import { getIcon } from "utils/iconsConfig";
import Selectinput from "./components/Selectinput";
import ClientCalendarComp from "./components/client_calendar/ClientCalendarComp";
import { useNavigate, useLocation } from "react-router-dom";
import { useGlobalContext } from "context/GlobalContext";
import useGatiClients from "./api/useGatiClientsNamesDetails";
import apiClient from "lib/api-client";
import { toast } from "react-toastify";
import { formatDate } from "utils/formatDate";
import MultiMobileEmail from "./components/MultiMobileEmail";
import { useDispatch } from "react-redux";
import { clearCart } from "store/cartSlice";

const getTenthValidDate = () => {
  const today = new Date();
  const cursor = new Date(today);
  cursor.setDate(today.getDate() + 1); // start from tomorrow

  let count = 0;

  while (count < 10) {
    if (cursor.getDay() !== 0) {
      count++;
    }

    if (count < 10) {
      cursor.setDate(cursor.getDate() + 1);
    }
  }

  return cursor;
};

const ClientDetailsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [clientName, setClientName] = useState({
    name: "",
    partyNumber: null,
    partyCode: "",
  });

  const [errors, setErrors] = useState({
    clientName: "",
    newClientName: "",
    bookType: "",
  });

  const [phoneNumber, setPhoneNumber] = useState([""]);
  const [email, setEmail] = useState([""]);

  const [newClientName, setNewClientName] = useState("");
  const [poNumber, setPoNumber] = useState("");
  const [bookType, setBookType] = useState("");
  const [stamps, setStamps] = useState("");
  const [certificate, setCertificate] = useState("");
  const [remarks, setRemarks] = useState("");
  const [priority, setPriority] = useState("");
  const [deliveryDate, setDeliveryDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const { setCartData, cartData } = useGlobalContext();
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [options, setOptions] = useState([]);
  const calendarRef = useRef(null);
  const notClient = clientName.name === "Binny’s Jewellery Pvt. Ltd. (Client not Found)";
  // const AllFieldFilled = (notClient ? newClientName : clientName && poNumber) && bookType && certificate && priority && deliveryDate && cartData.length !== 0;
  const isCrmFlow = Boolean(location.state?.crmSource);
  const crmFlowName = location.state?.crmFlowName || "";
  const isOrderFlow = crmFlowName === "Create Order";
  const isLeadId = location.state?.leadId || null;
  const AllFieldFilled = (notClient ? newClientName : clientName.name) && (isCrmFlow || bookType) && certificate && priority && deliveryDate && cartData.length !== 0;
  const hasErrors = errors?.bookType || errors?.clientName || (notClient && errors?.newClientName);
  // errors?.phoneNumber?.some(Boolean) ||
  // errors?.email?.some(Boolean) ||
  // phoneNumber.every((p) => p.trim() == "") ||
  // email.every((e) => e.trim() == "");

  const { data } = useGatiClients();

  const dispatch = useDispatch();

  // Dedupe + sort once per data change, not on every render
  const clientOptions = useMemo(() => {
    const uniqueMap = new Map();
    options.forEach((opt) => {
      const key = `${opt.clientName}-${opt.partyCode}`;
      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, opt);
      }
    });
    const collator = new Intl.Collator();
    return Array.from(uniqueMap.values())
      .sort((a, b) => collator.compare(a.clientName, b.clientName))
      .map((opt) => ({
        label: `${opt.clientName} (${opt.partyCode})`,
        value: `${opt.clientName} (${opt.partyCode})`,
        clientName: opt.clientName,
        partyCode: opt.partyCode,
        clientId: opt.clientId || opt._id,
        partyNo: opt.partyNo,
        firmEmail: opt.firmEmail || [],
        otherFirmEmail: opt.otherFirmEmail || [],
        whatsAppNo: opt.whatsAppNo || [],
        otherWhatsAppNo: opt.otherWhatsAppNo || [],
      }));
  }, [options]);

  useEffect(() => {
    if (data) {
      const filtered = data?.filter((item) => item.clientName !== "(As Per Detail)");
      setOptions(filtered);

      const storedData = sessionStorage.getItem("clientFormData");
      if (storedData) {
        const parsed = JSON.parse(storedData);
        if (parsed.clientName?.partyCode && (!parsed.emails || parsed.emails?.[0] === "")) {
          const match = filtered.find((opt) => opt.partyCode === parsed.clientName.partyCode);
          if (match) {
            const allEmails = [...(match.firmEmail || []), ...(match.otherFirmEmail || [])].filter((e) => e?.trim());
            const allPhones = [...(match.whatsAppNo || []), ...(match.otherWhatsAppNo || [])]
              .filter((p) => {
                const clean = p?.replace(/^\+91|^91/, "").trim();
                return clean && clean !== "91" && clean.length >= 10;
              })
              .map((p) => p.replace(/^\+91|^91/, ""));
            const emailsToSet = allEmails.length > 0 ? allEmails : [""];
            const phonesToSet = allPhones.length > 0 ? allPhones : [""];
            const updatedClientName = { ...parsed.clientName, partyNumber: match.partyNo ?? match.partyNumber ?? null };
            setClientName(updatedClientName);
            setEmail(emailsToSet);
            setPhoneNumber(phonesToSet);
            sessionStorage.setItem("clientFormData", JSON.stringify({
              ...parsed,
              clientName: updatedClientName,
              emails: emailsToSet,
              phoneNumbers: phonesToSet,
            }));
          }
        }
      }
    }
  }, [data]);

  const handleSearchClear = () => {
    setClientName({ name: "", partyNumber: null, partyCode: "" });
    setNewClientName("");
    setPoNumber("");
    setBookType("");
    setStamps("");
    setCertificate("");
    setRemarks("");
    setPriority("");
    setDeliveryDate(null);
  };

  // Link created Gati quote back to CRM lead (design + stock quote flows)
  const linkQuoteToLead = async (response) => {
    if (!isLeadId) return;
    const isLinkquoteNumber = await apiClient.post(`${process.env.REACT_APP_CRM_SERVER_URL}/api/v1/workflow/sales/linkQuoteNumbers`, {
      leadId: isLeadId,
      gatiOrderId: response?.data?.gatiOrderId,
      quoteNumbers: [response?.data?.gatiOrderNo],
    });
    console.log("isLinkquoteNumber", isLinkquoteNumber);
  };

  const placeOrder = async (payload) => {
    try {
      if (isCrmFlow) {
        if (isOrderFlow) {
          const response = await apiClient.post(`/api/v13/crm/createCRMOrder`, payload);
          console.log("createCRMOrder", response);
          return response;
        } else {
          const response = await apiClient.post(`/api/v13/crm/createCRMQuote`, payload);
          await linkQuoteToLead(response);
          console.log("createCRMOrder Quote", response);
          return response;
        }
      } else {
        const response = await apiClient.post(`/api/v3/client/vision_order/createVisionOrder`, payload);
        return response;
      }
    } catch (error) {
      console.error("Error placing order:", error);
      throw error;
    }
  };

  const placeOrderStock = async (payload) => {
    try {
      if (isCrmFlow) {
        const response = await apiClient.post(`/api/v13/crm/createCRMOrderForStock`, payload);
        await linkQuoteToLead(response);
        return response;
      } else {
        const response = await apiClient.post(`/api/v3/client/vision_order/createVisionOrderForStock`, payload);
        return response;
      }
    } catch (error) {
      console.error("Error placing stock order:", error);
      throw error;
    }
  };

  const cartLineToDesignFields = (cartDesign) => ({
    itemSize: cartDesign?.itemSize,
    diaQlty: cartDesign?.diaQlty,
    goldQlty: cartDesign?.goldQlty,
    goldColor: cartDesign?.goldColor,
    rhodium: cartDesign?.rhodium,
    message: cartDesign?.message,
    itemPoNo: cartDesign?.itemPoNo,
    ...(cartDesign?.orderQty != null ? { orderQty: cartDesign.orderQty } : {}),
    ...(cartDesign?.uploadFile ? { uploadFile: cartDesign.uploadFile } : {}),
  });

  const handleSubmit = async () => {
    try {
      const newErrors = {};
      setHasSubmitted(true);
      if (!clientName?.name || !clientName?.partyCode) {
        newErrors.clientName = "Please select a client.";
      }

      if (notClient && !newClientName.trim()) {
        newErrors.newClientName = "Client name is required for new user.";
      }

      if (!isCrmFlow && !bookType) {
        newErrors.bookType = "Please select a book type.";
      }

      // Email validation
      // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      // const phoneErrors = phoneNumber?.map((phone) => {
      //   const trimmedPhone = phone.trim();

      //   const numberOnly = trimmedPhone.startsWith("+91") ? trimmedPhone.slice(3) : trimmedPhone.startsWith("91") ? trimmedPhone.slice(2) : trimmedPhone;

      //   if (numberOnly === "") return "Phone number is required";
      //   if (numberOnly.length !== 10 || !/^\d{10}$/.test(numberOnly)) return "Phone number must be exactly 10 digits";

      //   return "";
      // });

      // if (phoneErrors.some((err) => err)) {
      //   newErrors.phoneNumber = phoneErrors;
      // }

      // if (phoneNumber.length === 0) {
      //   newErrors.phoneNumber = "Phone number is required";
      // }

      // const emailErrors = email?.map((e) => (e.trim() === "" ? "Email is required" : !emailRegex.test(e.trim()) ? "Invalid email format" : ""));
      // if (emailErrors.some((err) => err)) {
      //   newErrors.email = emailErrors;
      // }
      // if (email.length === 0) {
      //   newErrors.email = "Email is required";
      // }

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return;
      } else {
        setErrors(newErrors);
      }
      setLoading(true);
      const cartDesigns = JSON.parse(sessionStorage.getItem("CartData")) || [];

      const dateObj = new Date(deliveryDate);

      const day = String(dateObj.getDate()).padStart(2, "0");
      const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Months are 0-based
      const year = dateObj.getFullYear();

      const formattedDate = `${day}/${month}/${year}`;

      const hasJewelCode = (d) => Boolean(String(d?.jewelCode ?? "").trim());
      const designs = cartDesigns
        .filter((d) => !hasJewelCode(d))
        .map((cartDesign) => {
          return {
            ...cartLineToDesignFields(cartDesign),
            styleRef: cartDesign?.id,
            styleNumber: cartDesign?.styleNumber,
          };
        });
      const stockDesigns = cartDesigns.filter(hasJewelCode).map((cartDesign) => {
        return {
          ...cartLineToDesignFields(cartDesign),
          jewelCode: String(cartDesign.jewelCode).trim(),
        };
      });

      const basePayload = {
        clientName: notClient ? newClientName : clientName.name,
        partyNo: clientName.partyNumber,
        partyCode: clientName.partyCode,
        purchausOrder: poNumber,
        bookType,
        certificate,
        priority,
        deliveryDate: formattedDate,
        remarks,
        stampInstruction: stamps,
        phoneNumbers: phoneNumber?.filter((phone) => phone?.trim() !== ""),
        emails: email?.filter((em) => em?.trim() !== ""),
      };

      if (designs?.length) {
        await placeOrder({ ...basePayload, designs });
      }

      // console.log("stockDesigns", stockDesigns);
      if (stockDesigns?.length) {
        await placeOrderStock({ ...basePayload, designs: stockDesigns });
      }

      setCartData([]);
      dispatch(clearCart());
      handleSearchClear();
      sessionStorage.removeItem("clientFormData");

      // Collection Flow Navigation Done
      if (isCrmFlow) {
        const state = { ...location.state };
        navigate(`/OrderPlaceScreen`, { state });
        setTimeout(() => window.location.replace(location.state?.backPath), 2000);
      } else {
        const state = { ...location.state };
        navigate(`/OrderPlaceScreen`, { state });
      }
    } catch (err) {
      console.error("Failed to place order:", err);
      toast.error(err?.response?.data?.message, {
        autoClose: 3000,
        hideProgressBar: false,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const data = sessionStorage.getItem("clientFormData");
    if (data) {
      const parsed = JSON.parse(data);
      if (parsed.clientName) setClientName(parsed.clientName);
      if (parsed.poNumber) setPoNumber(parsed.poNumber);
      if (parsed.newClientName) setNewClientName(parsed.newClientName);
      if (parsed.bookType) setBookType(parsed.bookType);
      if (parsed.stamps) setStamps(parsed.stamps);
      if (parsed.deliveryDate) {
        setDeliveryDate(parsed.deliveryDate);
      } else {
        setDeliveryDate(formatDate(getTenthValidDate()));
      }

      if (parsed.certificate) {
        setCertificate(parsed.certificate);
      } else {
        setCertificate("None");
      }
      if (parsed.remarks) setRemarks(parsed.remarks);
      if (parsed.priority) {
        setPriority(parsed.priority);
      } else {
        setPriority("Standard");
      }

      if (parsed?.phoneNumbers) {
        setPhoneNumber(parsed.phoneNumbers);
      }

      if (parsed?.emails) {
        setEmail(parsed.emails);
      }
    } else {
      setCertificate("None");
      setPriority("Standard");
      setDeliveryDate(formatDate(getTenthValidDate()));
    }
  }, []);

  useEffect(() => {
    const defaultBookType = isCrmFlow && isOrderFlow ? "CRM Order" : "CRM Quote";
    setBookType(defaultBookType);
    updateSession("bookType", defaultBookType);
  }, [isCrmFlow, isOrderFlow]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setCalendarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Helper to get full session object
  const getSessionData = () => {
    const data = sessionStorage.getItem("clientFormData");
    return data ? JSON.parse(data) : {};
  };

  const updateSession = (field, value) => {
    const current = getSessionData();
    // setHasSubmitted(false);
    sessionStorage.setItem("clientFormData", JSON.stringify({ ...current, [field]: value }));
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            backgroundColor: "rgba(0, 0, 0, 0.6)",
          }}
        >
          <CircularProgress color="success" />
        </div>
      )}
      <Box className="Client-form-container">
        <Box className="sub-Client-form">
          {/* --------------------------  Row 1 -------------------*/}
          {/* Client namme 1 */}
          <div className="Field">
            <label className={`Field-label ${notClient ? "hide" : ""} `}>Client Name</label>
            <div>
              <SearchAndSelect
                value={
                  clientName.name && clientName.partyCode
                    ? (() => {
                        const match = options.find((opt) => opt.clientName === clientName.name && opt.partyCode === clientName.partyCode);
                        return match ? `${match.clientName} (${match.partyCode})` : null;
                      })()
                    : null
                }
                onchange={(selectedOption) => {
                  if (!selectedOption || !selectedOption.partyCode) {
                    const resetClient = { name: "", partyNumber: null, partyCode: "" };
                    setClientName(resetClient);
                    setPhoneNumber([""]);
                    setEmail([""]);
                    sessionStorage.setItem(
                      "clientFormData",
                      JSON.stringify({
                        ...JSON.parse(sessionStorage.getItem("clientFormData") || "{}"),
                        clientName: resetClient,
                        phoneNumbers: [""],
                        emails: [""],
                      })
                    );
                    return;
                  }

                  const selectedClient = {
                    name: selectedOption.clientName,
                    partyNumber: selectedOption.partyNo,
                    partyCode: selectedOption.partyCode,
                  };

                  // Process emails
                  const allEmails = [...(selectedOption.firmEmail || []), ...(selectedOption.otherFirmEmail || [])].filter((email) => email?.trim());

                  // Process phone numbers
                  const allPhones = [...(selectedOption.whatsAppNo || []), ...(selectedOption.otherWhatsAppNo || [])]
                    .filter((phone) => {
                      const cleanPhone = phone?.replace(/^\+91|^91/, "").trim();
                      return cleanPhone && cleanPhone !== "91" && cleanPhone.length >= 10;
                    })
                    .map((phone) => phone.replace(/^\+91|^91/, ""));

                  // Set state
                  const emailsToSet = allEmails.length > 0 ? allEmails : [""];
                  const phonesToSet = allPhones.length > 0 ? allPhones : [""];

                  setClientName(selectedClient);
                  setEmail(emailsToSet);
                  setPhoneNumber(phonesToSet);
                  setErrors((prev) => ({ ...prev, clientName: "" }));

                  sessionStorage.setItem(
                    "clientFormData",
                    JSON.stringify({
                      ...JSON.parse(sessionStorage.getItem("clientFormData") || "{}"),
                      clientName: selectedClient,
                      emails: emailsToSet,
                      phoneNumbers: phonesToSet,
                    })
                  );
                }}
                handleSearchClear={() => {
                  const empty = { name: "", partyNumber: null, partyCode: "" };
                  setClientName(empty);
                  sessionStorage.setItem(
                    "clientFormData",
                    JSON.stringify({
                      ...JSON.parse(sessionStorage.getItem("clientFormData") || "{}"),
                      clientName: empty,
                    })
                  );
                }}
                isError={Boolean(errors.clientName)}
                options={clientOptions}
                showSearch={true}
                filterOption={(input, option) => {
                  if (!input) return true;
                  const searchTerm = input.toLowerCase().trim();
                  const label = option.label?.toLowerCase() || "";
                  return label.includes(searchTerm);
                }}
                filterSort={(optionA, optionB, inputValue) => {
                  return optionA.label.toLowerCase().indexOf(inputValue.toLowerCase()) - optionB.label.toLowerCase().indexOf(inputValue.toLowerCase());
                }}
                style={{
                  background: "transparent",
                  color: "#fff",
                  border: "none",
                  width: "100%",
                  height: "5.2vh",
                  padding: "10px",
                  fontFamily: "Poppins",
                  fontSize: "16px",
                  outline: "none",
                }}
              />
              {errors.clientName && <span style={{ color: "#F23D3D", fontSize: "12px", width: "100%" }}>{errors.clientName}</span>}
            </div>
          </div>
          {/* New Client Name and PO  */}
          <div className="Field">
            <label className={`Field-label ${notClient ? "hide" : ""} `}>PO.No.</label>
            <div>
              <input
                className="Field-input"
                type="text"
                style={{ border: notClient && errors.newClientName ? "1px solid #F23D3D" : "", background: notClient && errors.newClientName ? "#F23D3D08" : "transparent" }}
                placeholder={notClient ? "Enter Client Name" : "Enter purchase order number"}
                value={notClient ? newClientName : poNumber}
                // onChange={(e) => (notClient ? setNewClientName(e.target.value) : setPoNumber(e.target.value))}
                onChange={(e) => {
                  if (notClient) {
                    setNewClientName(e.target.value);
                    updateSession("newClientName", e.target.value);
                    setErrors((prev) => ({ ...prev, newClientName: "" }));
                  } else {
                    setPoNumber(e.target.value);
                    updateSession("poNumber", e.target.value);
                  }
                }}
              />
              {notClient && errors.newClientName && <span style={{ color: "#F23D3D", fontSize: "12px", width: "100%" }}>{errors.newClientName}</span>}
            </div>
          </div>
          {/* Book Type */}
          <div className="Field">
            <label className="Field-label">Book Type</label>
            <input className="Field-input" type="text" value={isCrmFlow && isOrderFlow ? "CRM Order" : "CRM Quote"} disabled={true} />
          </div>
          {/* --------------------------  Row 2 -------------------*/}
          {/* Mobile  */}
          <MultiMobileEmail phoneNumber={phoneNumber} setPhoneNumber={setPhoneNumber} updateSession={updateSession} Field={"phoneNumber"} errors={errors} setErrors={setErrors} />
          {/* Email */}
          <MultiMobileEmail email={email} setEmail={setEmail} updateSession={updateSession} Field={"Email"} errors={errors} setErrors={setErrors} />
          {/* Certificate */}
          <div className="Field">
            <label className="Field-label">Certification</label>
            <Selectinput
              options={["IGI", "DGLA", "SGL", "GIA", "GSI", "None"]}
              value={certificate}
              onchange={(e) => {
                setCertificate(e.target.value);
                updateSession("certificate", e.target.value);
              }}
              placeHolder={"Select Certificate"}
            />
          </div>
          {/* --------------------------  Row 3 -------------------*/}
          {/* Stamp Intruction */}
          <div className="Field">
            <label className="Field-label">Stamp Instruction</label>
            <input
              className="Field-input"
              type="text"
              placeholder="Enter instruction"
              value={stamps}
              onChange={(e) => {
                setStamps(e.target.value);
                updateSession("stamps", e.target.value);
              }}
            />
          </div>
          {/* Delivery Date */}
          <div className="Field">
            <label className="Field-label">Delivery Date</label>

            <div style={{ position: "relative" }} ref={calendarRef}>
              <div className="field-sub" style={{ cursor: "pointer" }} onClick={() => setCalendarOpen((prev) => !prev)}>
                <input className="Field-input" placeholder="Select Date" type="text" value={deliveryDate} readOnly />
                <span>{getIcon("date")}</span>
              </div>

              {calendarOpen && (
                <div
                  style={{
                    position: "absolute",
                    top: "80%",
                    right: 0,
                    zIndex: 1000,
                    marginTop: "0.5vw",
                  }}
                >
                  <ClientCalendarComp
                    selectedDate={deliveryDate}
                    onDateSelect={(date) => {
                      setDeliveryDate(date);
                      updateSession("deliveryDate", date);
                      setAnchorEl(null);
                      setCalendarOpen(false);
                    }}
                  />
                </div>
              )}
            </div>
          </div>

          {/*Priority  */}
          <div className="Field">
            <label className="Field-label">Priority</label>
            <Selectinput
              options={["Standard", "Urgent"]}
              value={priority}
              onchange={(e) => {
                setPriority(e.target.value);
                updateSession("priority", e.target.value);
              }}
              placeHolder={"Standard"}
            />
          </div>
          {/* --------------- Row 4 --------------------- */}
          {/* tyle={{ color: "#E77B7B", fontSize: "0.9vw", fontFamily: "poppins", width: "100%" }} */}
          {/* Remarks */}
          <div className="Field Field-occupy">
            <div className="Field Field-occupy">
              <label className="Field-label">Remarks</label>
              <input
                className="Field-input"
                type="text"
                placeholder="Enter your message"
                value={remarks}
                onChange={(e) => {
                  setRemarks(e.target.value);
                  updateSession("remarks", e.target.value);
                }}
              />
            </div>
          </div>
        </Box>

        <Box className="btn-container">
          <button type="submit" onClick={() => handleSubmit()} className={`order-btn ${!hasErrors && AllFieldFilled ? "order-btn-success" : "order-btn-disable"}`}>
            {isCrmFlow && isOrderFlow ? "Generate Order" : "Generate Quote"}
          </button>
        </Box>
      </Box>
    </>
  );
};

export default ClientDetailsPage;
